import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AdminOpcionesSupervisoraMedia = () => {
  const navigate = useNavigate();
  const [supervisoras, setSupervisoras] = useState([]);
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [guardadas, setGuardadas] = useState([]); // última selección confirmada guardada en el servidor
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const cargar = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get("/api/servicio/opciones_supervisora_media");
      const filas = res.data?.supervisoras || [];
      const activas = filas.filter((f) => f.media).map((f) => f.user);
      setSupervisoras(filas);
      setSeleccionadas(activas);
      setGuardadas(activas);
    } catch (e) {
      setError(e.response?.data?.error || "❌ Error al cargar supervisoras.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const toggle = (user) => {
    setSeleccionadas((prev) =>
      prev.includes(user) ? prev.filter((u) => u !== user) : [...prev, user]
    );
  };

  const marcarTodas = () => setSeleccionadas(supervisoras.map((s) => s.user));
  const desmarcarTodas = () => setSeleccionadas([]);

  const dirty = (() => {
    if (seleccionadas.length !== guardadas.length) return true;
    const a = [...seleccionadas].sort();
    const b = [...guardadas].sort();
    return a.some((v, i) => v !== b[i]);
  })();

  const guardar = async () => {
    setGuardando(true);
    setError("");
    try {
      await axios.put("/api/servicio/opciones_supervisora_media", { seleccionadas });
      setGuardadas(seleccionadas);
    } catch (e) {
      setError(e.response?.data?.error || "❌ Error al guardar.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4f8", padding: "24px 16px" }}>
      <div style={{ maxWidth: 700, margin: "0 auto" }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: "#3b82f6", fontWeight: 700, marginBottom: 20, padding: 0 }}
        >
          ← Volver
        </button>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: "#1e3a5f", marginBottom: 12 }}>
          📊 Media de supervisoras
        </h2>

        {!loading && supervisoras.length > 0 && (
          <div style={{
            display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
            padding: "12px 16px", borderRadius: 14, marginBottom: 16,
            background: dirty ? "#dc2626" : "#f0fdf4",
            border: dirty ? "none" : "1.5px solid #86efac",
            boxShadow: dirty ? "0 4px 16px rgba(220,38,38,0.25)" : "none",
          }}>
            <span style={{ flex: 1, fontSize: 13.5, fontWeight: 700, color: dirty ? "#fff" : "#15803d", minWidth: 180 }}>
              {dirty ? "⚠️ Tienes cambios sin guardar — pulsa Guardar para aplicarlos" : "✅ Todo guardado"}
            </span>
            <button onClick={guardar} disabled={guardando || !dirty} style={{
              background: dirty ? "#fff" : "#e2e8f0", color: dirty ? "#dc2626" : "#94a3b8",
              border: "none", borderRadius: 10, padding: "10px 22px", fontWeight: 800, fontSize: 14,
              cursor: dirty && !guardando ? "pointer" : "not-allowed",
            }}>
              {guardando ? "Guardando…" : "💾 Guardar"}
            </button>
          </div>
        )}

        <div style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 12, padding: "12px 16px", marginBottom: 20, fontSize: 14, color: "#1e40af" }}>
          Selecciona qué supervisoras cuentan para calcular la "media" de gasto semanal (en
          Análisis de datos y en el panel "Ver datos compras" de cada supervisora). Solo las
          seleccionadas tendrán acceso a ese panel.
        </div>

        {error && <div style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 10, padding: "10px 14px", marginBottom: 16 }}>{error}</div>}

        {loading ? (
          <div style={{ textAlign: "center", color: "#64748b", padding: 40 }}>Cargando...</div>
        ) : supervisoras.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 14, padding: 32, textAlign: "center", color: "#94a3b8" }}>
            No hay supervisoras activas.
          </div>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 10 }}>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  background: "#dcfce7",
                  color: "#15803d",
                  border: "1.5px solid #86efac",
                  borderRadius: 999,
                  padding: "6px 14px",
                  fontSize: 13,
                  fontWeight: 800,
                }}
              >
                ✅ {seleccionadas.length} de {supervisoras.length} seleccionadas
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button
                  onClick={marcarTodas}
                  style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 8, padding: "6px 12px", cursor: "pointer", color: "#3b82f6", fontWeight: 600, fontSize: 13 }}
                >
                  Marcar todas
                </button>
                <button
                  onClick={desmarcarTodas}
                  style={{ background: "#f8fafc", border: "1.5px solid #e2e8f0", borderRadius: 8, padding: "6px 12px", cursor: "pointer", color: "#475569", fontWeight: 600, fontSize: 13 }}
                >
                  Desmarcar todas
                </button>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                gap: 12,
                marginBottom: 20,
              }}
            >
              {supervisoras.map((s) => {
                const activa = seleccionadas.includes(s.user);
                return (
                  <label
                    key={s.user}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      padding: "14px 16px",
                      borderRadius: 14,
                      cursor: "pointer",
                      userSelect: "none",
                      background: activa ? "#dcfce7" : "#f1f5f9",
                      border: activa ? "2px solid #4ade80" : "2px solid #e2e8f0",
                      boxShadow: activa ? "0 4px 14px rgba(34,197,94,0.18)" : "0 1px 4px rgba(0,0,0,0.04)",
                      transition: "background 0.15s, border-color 0.15s, box-shadow 0.15s",
                    }}
                  >
                    <div
                      style={{
                        width: 38,
                        height: 38,
                        minWidth: 38,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 800,
                        fontSize: 15,
                        color: "#fff",
                        background: activa ? "#22c55e" : "#94a3b8",
                        transition: "background 0.15s",
                      }}
                    >
                      {(s.nombre || s.user).charAt(0).toUpperCase()}
                    </div>
                    <div
                      style={{
                        flex: 1,
                        fontSize: 15,
                        fontWeight: 700,
                        color: activa ? "#15803d" : "#475569",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {s.nombre || s.user}
                    </div>
                    <input
                      type="checkbox"
                      checked={activa}
                      onChange={() => toggle(s.user)}
                      style={{ width: 18, height: 18, cursor: "pointer", accentColor: "#22c55e" }}
                    />
                  </label>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminOpcionesSupervisoraMedia;
